import { normalizeEntityType } from 'app/utils/classification/classificationUtils';

export const entityLink = (id, type, path) => {
    return `/#${entityRouteLink(id, type, path)}`;
};

export const entityRouteLink = (id, type, path) => {
    const normalizedType = normalizeEntityType(type);
    const detailPath = {
        system_task: 'abox/task',
        system_process: 'abox/process',
        workspace: 'workspaces',
    }[normalizedType];
    const tab = path ? `/${path}` : '';
    if (detailPath) {
        return `/${detailPath}/${id}${tab}`;
    }
    return `/entities/${normalizedType}/${id}${tab}`;
};
